import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { Link } from '@tanstack/react-router';
import { MenuIcon } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { Menu } from '@/components/menu/Menu';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { cn } from '@/lib/utils';

import { useTheme } from '../providers/ThemeProvider';

export const SheetMenu = (): JSX.Element => {
  const { resolvedTheme } = useTheme();
  const logoSrc =
    resolvedTheme === 'dark' ? '/LogoWhite.svg' : '/LogoBlack.svg';

  return (
    <Sheet>
      <SheetTrigger className="lg:hidden" asChild>
        <Button className="h-8" variant="outline" size="icon">
          <MenuIcon size={20} />
        </Button>
      </SheetTrigger>
      <SheetContent
        className="w-48 px-3 h-full flex flex-col py-4 gap-1"
        side="left"
        aria-describedby={undefined}
      >
        <VisuallyHidden>
          <SheetTitle>
            <FormattedMessage id="global.menu.title" />
          </SheetTitle>
        </VisuallyHidden>
        <SheetHeader>
          <Button
            className={cn('transition-transform ease-in-out duration-300')}
            variant="link"
            asChild
          >
            <Link to="/" className="flex items-center gap-2">
              <img
                src={logoSrc}
                alt="Logo"
                className={cn(
                  'transition-[width,height] ease-in-out duration-300',
                  'w-24 h-12',
                )}
              />
            </Link>
          </Button>
        </SheetHeader>
        <Menu />
      </SheetContent>
    </Sheet>
  );
};
